module.exports = __webpack_public_path__ + "img/logo.aeef4c1d.png";